import "../../node_modules/react-modal-video/scss/modal-video.scss";
import { useTranslation } from "react-i18next";
import LogoBig from "../assets/images/logo-ana-labs-technologies.png";
import AnimateOnScroll from './AnimateOnScroll';

export default function About() {
	const { t } = useTranslation();

	const values = [
		t("About.value1"),
		t("About.value2"),
		t("About.value3"),
		t("About.value4"),
		t("About.value5"),
	];

	return (
		<section className="py-20 bg-white" id="about">
			<div className="container">
				<AnimateOnScroll>
					<div className="text-center mb-14">
						<p className="t-h1">{t("About.label", "ABOUT US")}</p>
						<h2 className="t-h2 max-w-2xl mx-auto">{t("About.aboutUs")}</h2>
					</div>
				</AnimateOnScroll>

				<div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
					{/* Left: Who we are */}
					<AnimateOnScroll animation="fadeRight">
						<div>
							<h3
								className="font-bold mb-5"
								style={{
									fontFamily: '"Wix Madefor Display", sans-serif',
									fontSize: '1.5rem',
									color: '#010C66',
								}}
							>
								{t("About.whoWeAre")}
							</h3>
							<p style={{ color: '#6b7280', lineHeight: 1.8, fontSize: '0.95rem', marginBottom: '1rem' }}>
								{t("About.whoWeAreContentP1")}
							</p>
							{t("About.whoWeAreContentP2") && (
								<p style={{ color: '#6b7280', lineHeight: 1.8, fontSize: '0.95rem' }}>
									{t("About.whoWeAreContentP2")}
								</p>
							)}
						</div>
					</AnimateOnScroll>

					{/* Right: Values + logo */}
					<AnimateOnScroll animation="fadeLeft">
						<div className="flex flex-col gap-8">
							<div>
								<h3
									className="font-bold mb-5"
									style={{
										fontFamily: '"Wix Madefor Display", sans-serif',
										fontSize: '1.5rem',
										color: '#010C66',
									}}
								>
									{t("About.values")}
								</h3>
								<ul className="space-y-3">
									{values.map((value, i) => (
										<li key={i} className="flex items-center gap-3">
											<div
												className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
												style={{ background: '#f0f2ff' }}
											>
												<svg width="10" height="10" viewBox="0 0 24 24" fill="none">
													<path d="M20 6L9 17l-5-5" stroke="#010C66" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
												</svg>
											</div>
											<span style={{ color: '#374151', fontWeight: 500, fontSize: '0.95rem' }}>{value}</span>
										</li>
									))}
								</ul>
							</div>

							<div className="flex items-center gap-4">
								<img
									src={LogoBig}
									alt="ANA Labs Logo"
									className="h-20 w-auto object-contain"
								/>
							</div>
						</div>
					</AnimateOnScroll>
				</div>
			</div>
		</section>
	);
}
